/**
 * Foursource page
 * https://foursource.com/sustainability/gots-x-foursource
 */

import * as React from "react";
import { withTrans } from "../../i18n/withTrans";
import Utm from "../../components/_global/utm";
import { pageTexts } from "../../content/gots-x-foursource";
import { searchTexts } from "../../content/pages/searchCerts";
import { StaticImage } from "gatsby-plugin-image";

// components
import Layout from "../../components/layout";
import TextImgBackgroundFull from "../../components/textImgBackgroundFull";
import Text from "../../components/text";
import TitleSeparator from "../../components/titleSeparator";
import Button from "../../components/_partials/_button";
import BulletsSection from "../../components/bulletsSection";

class gotsPage extends React.Component {
  constructor(props) {
    super(props);
    this.t = props.t;
    this.text = pageTexts(this.t);
    this.searchTexts = searchTexts(this.t);
    this.searchTexts.searchText.subtitle.text = this.t("sustainability.gots-x-foursource.searchingGOTS");
  }

  render() {
    return (
      <>
        <Layout pageName="sustainability.gots-x-foursource" whiteMenu={false}>
          <TextImgBackgroundFull info={this.text.topInfo}></TextImgBackgroundFull>
          <div className="paddingSidesBig pt-30 pb-50">
            <Text text={this.text.firstText}></Text>
          </div>
          <div className="paddingSidesBig backgroundGrey topBottomDiagonal pt-30">
            <div className="pt-100 pb-100">
              <TitleSeparator info={this.text.whatIs}></TitleSeparator>
              <Text text={this.text.whatIsText}></Text>
              <div className="imgCenter text-center">
                <StaticImage src="../../images/gots-logo.png" placeholder="blurred" alt={this.t("sustainability.gots.imgAlt")} />
              </div>
              <div className="pt-75">
                <TitleSeparator info={this.text.standards}></TitleSeparator>
                <div className="row row-cols-lg-2 row-cols-md-2 row-cols-sm-1 m-0">
                  {this.text.standardsCols.map((col, i) => (
                    <BulletsSection key={i} info={col} num={i}></BulletsSection>
                  ))}
                </div>
                <div className="row justify-content-center">
                  <Button cta={this.text.GOTSButton}></Button>
                </div>
              </div>
            </div>
          </div>
          <div className="paddingSidesBig pt-30">
            <BulletsSection info={this.searchTexts.searchText}></BulletsSection>
            <a href={process.env.GATSBY_CHINA === "true" ? `${process.env.APP_CHINA_URL}/signup/` : Utm(`${process.env.APP_URL}/signup/`)} target="_blank" rel="noreferrer">
            <div className="d-flex justify-content-center">
              <StaticImage
                src="../../images/gots-04022020.png"
                placeholder="blurred"
                alt={this.t("sustainability.gots.platformAlt")}
                className="h-100"
              />
              </div>
            </a>
            <div className="row justify-content-center pb-100">
              <Button cta={this.text.resultsButton}></Button>
            </div>
          </div>
        </Layout>
      </>
    );
  }
}

export default withTrans(gotsPage);
